import LedgerWebUSB from '@ledgerhq/hw-transport-webusb';
import LedgerU2F from '@ledgerhq/hw-transport-u2f';
import Web3ProviderEngine from 'web3-provider-engine';
import createLedgerSubprovider, { ICreateLedgerSubprovider } from './ledgerSubprovider';
import { getProviderEngine, getRpcProvider, promisify } from './utils';
import { HD_DERIVATION_PATHS, LEDGER_LS_KEY } from '../constants/wallet';

const getLedgerTransport = () => {
  const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  // const isFirefox = /firefox/.test(navigator.userAgent.toLowerCase());
  // @ledgerhq/hw-transport-webusb
  // @ledgerhq/hw-transport-webhid
  return Promise.resolve(isChrome ? LedgerWebUSB : LedgerU2F);
};

export const getLedgerSubProvider = () => Promise.resolve(createLedgerSubprovider);

const getLedgerTransportProvider = async (options: ICreateLedgerSubprovider) => {
  const [ledgerTransport, ledgerFactory] = await Promise.all([getLedgerTransport(), getLedgerSubProvider()]);
  return ledgerFactory(() => ledgerTransport.create(), options);
};

export const getLedgerEngine = async (options: ICreateLedgerSubprovider) => {
  const [ledgerProvider, ProviderEngine] = await Promise.all([getLedgerTransportProvider(options), getProviderEngine()]);
  ledgerProvider.signMessage = ledgerProvider.signPersonalMessage;
  const engine = new ProviderEngine();
  engine.addProvider(ledgerProvider);
  engine.isLedger = true;
  return engine;
};

type IGetLedgerProvider = (
  ledgerPath: string,
  networkId: number,
  rpcUrl: string,
  savePath: boolean
) => Promise<{ provider: Web3ProviderEngine, ledgerPath: string }>;

export const getLedgerProvider: IGetLedgerProvider = async (ledgerPath: string, networkId: number, rpcUrl: string, savePath: boolean) => {
  const options = {
    accountsLength: 1,
    networkId,
    paths: [ledgerPath], // || HD_DERIVATION_PATHS.LIVE.value
  };

  const [engine, provider] = await Promise.all([getLedgerEngine(options), getRpcProvider(rpcUrl)]);
  engine.addProvider(provider);
  engine.start();
  if (savePath) {
    localStorage.setItem(LEDGER_LS_KEY, ledgerPath);
  }
  return { provider: engine, ledgerPath };
};

interface IGetLedgerAccounts {
  ledgerPath: string
  networkId?: number
  accountsLength?: number
  accountsOffset: number
}

export const getLedgerAccounts = async ({
  ledgerPath, networkId, accountsLength = 5, accountsOffset = 0,
}: IGetLedgerAccounts) => {
  const options = {
    networkId,
    paths: [ledgerPath || HD_DERIVATION_PATHS.LIVE.value],
    accountsOffset,
    accountsLength,
  };
  const provider = await getLedgerTransportProvider(options);
  const addresses = await promisify<string[]>(provider.getAccounts, []);
  return addresses;
};

export const cleanUpLedgerTraces = () => localStorage.removeItem(LEDGER_LS_KEY);
